import { useEffect, useState } from 'react';
//import './Page3346Style.css';

function Page3346Success() {

  const [language, setLanguage] = useState('EN');

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    if (selectedLang === 'English') {
      setLanguage('AR');
    } else {
      setLanguage('EN');
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      setLanguage(language);
      return;
    }
    setLanguage(lang.toUpperCase());
  }, []);

  useEffect(() => {
  }, [language]);

  return (
    <div className="Aa3346">
      <div className='container'>
        <div className='header'>
          <div className="language" onClick={handleLanguage}>
            <span>{language === 'EN' ? 'English' : 'عربي'}</span>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Download is ready' : 'جاهز للتحميل'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img fetchpriority='high' alt='Ready' src='/tick.avif' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>{language === 'EN' ? 'Successful Operation' : 'تمت العملية بنجاح'}</h3>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default Page3346Success;